import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import Card from './card';
import Spacer from '../spacer';
import SectionTitle from '../section-title';
import useMobile from '../hooks/use-mobile';
export default function List(props) {
  const isMobile = useMobile();

  const isLast = item => props.list.length === props.list.indexOf(item) + 1;

  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(SectionTitle, {
    name: props.header,
    onPress: props.onPress,
    noTextButton: props.noTextButton
  }, "View All"), /*#__PURE__*/React.createElement(Spacer, {
    size: isMobile ? 'f12' : 'f16',
    height: true
  }), props.list.map(transaction => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    key: transaction.referenceNo,
    icon: transaction.icon,
    amount: transaction.amount,
    purpose: transaction.purpose,
    referenceNo: transaction.referenceNo,
    status: transaction.status,
    onPress: transaction.onPress,
    defaultText: props.defaultText
  }), !isLast(transaction) && /*#__PURE__*/React.createElement(Spacer, {
    size: isMobile ? 'f12' : 'f16',
    height: true
  }))));
}
List.defaultProps = {
  list: [],
  header: 'Payment Due',
  onPress: () => {},
  defaultText: 'No Payments Due',
  noTextButton: false
};
List.propTypes = {
  list: PropTypes.array,
  header: PropTypes.string,
  onPress: PropTypes.func,
  defaultText: PropTypes.string,
  noTextButton: PropTypes.bool
};
//# sourceMappingURL=list.js.map